/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

	/*
	 * - autoSmoothScroll -
	 * Fork-me on github : https://github.com/Yappli/smooth-scroll
	 * */
	window.smoothScroll = function(window, undefined)
	{
	    'use strict';
	    var height_fixed_header = 0, // For layout with header with position:fixed. Write here the height of your header for your anchor don't be hiden behind
	        speed = 500,
	        moving_frequency = 15, // Affects performance ! High number makes scroll more smooth
	        links = document.getElementsByTagName('a'),
	        href;
	    
	    for(var i = 0; i < links.length; i++)
	    {
	        href = (links[i].attributes.href === undefined) ? null : links[i].attributes.href.nodeValue.toString();
	        if(href !== null && href.length > 1 && href.indexOf('#') != -1) // href.substr(0, 1) == '#'
	        {
	            links[i].onclick = function()
	            {
	                var element,
	                    href = this.attributes.href.nodeValue.toString(),
	                    url = href.substr(0, href.indexOf('#')),
	                    offs = +(this.attributes.offset.nodeValue.toString()),
	                    id = href.substr(href.indexOf('#') + 1);
	                if (element = document.getElementById(id))
	                {
	
	                    var hop_count = (speed - (speed % moving_frequency)) / moving_frequency, // Always make an integer
	                        getScrollTopDocumentAtBegin = getScrollTopDocument(),
	                        gap = (getScrollTopElement(element) - getScrollTopDocumentAtBegin + offs) / hop_count;
	                    
	                    if (window.history && typeof window.history.pushState == 'function')
	                        window.history.pushState({}, undefined, url + '#' + id); // Change URL for modern browser
	
	                    for (var i = 1; i <= hop_count; i++)
	                    {
	                        (function()
	                        {
	                            var hop_top_position = gap * i;
	                            setTimeout(function(){  window.scrollTo(0, hop_top_position + getScrollTopDocumentAtBegin); }, moving_frequency * i);
	                        })();
	                    }
	
	                    return false;
	                }
	            };
	        }
	    }
	    
	    var getScrollTopElement =  function(e)
	    {
	        var top = height_fixed_header * -1;
	
	        while (e.offsetParent != undefined && e.offsetParent != null)
	        {
	            top += e.offsetTop + (e.clientTop != null ? e.clientTop : 0);
	            e = e.offsetParent;
	        }
	
	        return top;
	    };
	    
	    var getScrollTopDocument = function()
	    {
	        return window.pageYOffset !== undefined ? window.pageYOffset : document.documentElement.scrollTop !== undefined ? document.documentElement.scrollTop : document.body.scrollTop;
	    };
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// smooth_scroll.js